import { ANGOLAN_IBAN_PREFIX } from '»utils/constants';

import {
  CreateAccountDefaultFields,
  CreateAccountStinvestFields,
  createDefaultValidation,
  createStinvestValidation,
} from './Fields';

export const CREATE_ACCOUNT_VARIANTS = {
  default: {
    initialValues: {
      taxId: '',
      bankCode: '',
      bankAccountNumber: '',
      ibanCode: ANGOLAN_IBAN_PREFIX,
    },
    buildValidationSchema: createDefaultValidation,
    FieldsComponent: CreateAccountDefaultFields,
  },
  stinvest: {
    initialValues: {
      idType: '',
      idNumber: '',
      bankCode: '',
      ibanCode: ANGOLAN_IBAN_PREFIX,
      ibanCode2: '',
      email1: '',
    },
    buildValidationSchema: createStinvestValidation,
    FieldsComponent: CreateAccountStinvestFields,
  },
};
